<template>
  <div>
    <RegisterHeader @toLogin="toLogin" />
    <div class="Register">
      <h1>找回密码</h1>
      <div class="container">
        <div class="Steps">
          <div>
            <span>1</span>
            <!-- <img src="../assets/images/形状 4.png" alt="" /> -->
          </div>
          <div class="middle"></div>
          <div class="First" :class="active == 1 ? 'active2' : ''">
            <span>2</span>
          </div>
        </div>
        <el-row type="flex" justify="space-between">
          <span style="margin-left: 0.5rem">确认账号</span>
          <span :class="active == 0 ? 'isFirst' : ''">重置密码</span>
        </el-row>
        <el-form ref="ruleForm" :rules="rules" :model="ruleForm" class="Form" label-width="80px">
          <el-form-item v-show="active == 0" label="手机号:" prop="phone">
            <el-input v-model="ruleForm.phone"></el-input>
          </el-form-item>
          <el-form-item v-show="active == 0" label="验证码:" prop="input3">
            <el-input placeholder="请输入内容" v-model="ruleForm.input3" class="input-with-select">
              <el-button
                slot="append"
                @click="sendYzM"
                type="primary"
                plain
                :disabled="IsRegister"
                class="butan"
              >
                <span v-show="!CountDown">发送验证码</span>
                <span v-show="CountDown">{{ CountNum }}秒后可重发</span>
              </el-button>
            </el-input>
          </el-form-item>
          <el-form-item v-show="active == 1" label="密码" prop="pass">
            <el-input type="password" v-model="ruleForm.pass" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item v-show="active == 1" label="确认密码" prop="checkPass">
            <el-input type="password" v-model="ruleForm.checkPass" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button
              v-show="active == 1"
              type="primary"
              class="submitBtn"
              @click="onSubmit('ruleForm')"
            >确认修改</el-button>
            <el-button
              v-show="active == 0"
              class="submitBtn"
              @click="NextForm('ruleForm')"
              type="primary"
            >下一步</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>

    <Footer />
    <Login ref="login" />
  </div>
</template>

<script>
import { postAction } from '../api/api'
import { Register, Regist, library, pcapi } from '../api/url'
import Footer from '@/components/Footer'
import RegisterHeader from '@/components/RegisterHeader'
import Login from '@/components/Login'
export default {
  components: { Footer, RegisterHeader, Login },
  data() {
    //验证用户名
    var checkPhone = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('手机号不能为空'))
      }
      setTimeout(() => {
        var reg_tel =
          /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/ //11位手机号码正则
        if (reg_tel.test(value)) {
          let data = {
            action: 'Retrieve_Tel',
            mobile: value,
          }
          postAction(library, this.$qs.stringify(data)).then((res) => {
            if (res == 0) {
              callback(new Error('当前手机号未注册!'))
              this.IsRegister = true
            } else {
              this.IsRegister = false

              callback()
            }
          })
        } else {
          callback(new Error('请输入正确的手机号!'))
        }
      }, 100)
    }
    var validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'))
      } else {
        if (this.ruleForm.checkPass !== '') {
          this.$refs.ruleForm.validateField('checkPass')
        }
        callback()
      }
    }
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'))
      } else if (value !== this.ruleForm.pass) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }
    return {
      active: 0,
      subMiting: false,
      passwordRegChess: '',

      Province: [],
      city: [],
      TechFieldList: [],
      FirstUnit: [],
      SecondUnit: [],
      ruleForm: {
        phone: '',
        checkPass: '',
        pass: '',
        input3: '',
      },
      rules: {
        input3: [{ required: true, message: '请输入验证码', trigger: 'blur' }],
        phone: [{ validator: checkPhone, trigger: 'blur' }],
        pass: [{ validator: validatePass, trigger: 'blur' }],
        checkPass: [{ validator: validatePass2, trigger: 'blur' }],
      },

      nums: '',
      CountDown: false,
      CountNum: 60,
      Count: {},
      IsRegister: true,
    }
  },
  watch: {
    CountNum(val) {
      if (val == 0) {
        clearInterval(this.Count)
        this.CountDown = false
        this.IsRegister = false
        this.CountNum = 60
      }
    },
  },
  created() {},
  methods: {
    toLogin() {
      this.$refs.login.show()
    },
    sendYzM() {
      let data = {
        action: 'Get_RCode',
        Code: this.getRandomNum(),
        phoNum: this.ruleForm.phone,
      }
      postAction(library, this.$qs.stringify(data)).then((res) => {
        if (res.code == 0) {
          this.$message({
            showClose: false,
            message: '发送成功,请注意查收',
            type: 'success',
          })
          this.CountDown = true
          this.IsRegister = true
          this.BeginCount()
        }
      })
    },
    BeginCount() {
      this.Count = setInterval(() => {
        this.CountNum--
      }, 1000)
    },
    NextForm(FormName) {
      let vm = this
      var reg_tel =
        /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/ //11位手机号码正则
      if (!reg_tel.test(vm.ruleForm.phone)) {
        return false
      }
      let Datas = {
        action: 'Check_RCode',
        Code: vm.ruleForm.input3,
      }
      postAction(library, vm.$qs.stringify(Datas)).then((res) => {
        if (res == 1) {
          vm.active = 1
        } else {
          vm.$message.error('验证码错误，请重新获取!')
          return false
        }
      })
    },
    onSubmit(FormName) {
      this.$refs[FormName].validate((valid) => {
        if (valid) {
          let data = {
            action: 'Change_Password',
            tel: this.ruleForm.phone,
            pwd: this.ruleForm.pass,
          }
          postAction(library, this.$qs.stringify(data)).then((res) => {
            if (res == 0) {
              this.$message({
                showClose: false,
                message: '修改成功！',
                type: 'success',
              })
              this.$router.push('/')
            } else {
              vm.$message.error('修改失败，请重试!')
            }
            vm.$refs[FormName].resetFields()
          })
        }
      })
    },
    // 获取验证码
    getRandomNum() {
      let vm = this
      this.nums = ''
      for (var i = 0; i < 6; i++) {
        var random = Math.floor(Math.random() * 10)
        this.nums += random
      }
      return this.nums
      ////// console.log('自动生成随机数', vm.randomNum);
    },
  },
}
</script>

<style lang='scss' scoped>
.Register {
  position: absolute;
  top: 10.9375rem;
  left: 0;
  right: 0;
  h1 {
    margin-bottom: 3.25rem;
  }
}
.container {
  width: 87.5rem;
  height: 31.25rem;
  background: #ffffff;
  margin: 0 auto;
  box-shadow: 0rem 0.1875rem 1rem rgba(0, 0, 0, 0.08);
  box-sizing: border-box;
  padding-top: 3.75rem;
}
h1 {
  font-size: 2.625rem;
  font-family: PingFang SC;
  font-weight: 500;
  line-height: 2.9375rem;
  color: #ffffff;
  margin: 0;
}
.el-row {
  width: 41.625rem;
  margin: 0 auto;
  color: #2769dc;
  font-size: 16px;
  font-family: Microsoft YaHei;
}
.Steps {
  width: 40.625rem;
  height: 5.25rem;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 1.25rem;
  font-family: Microsoft YaHei;
  color: #fff;
  div {
    width: 3rem;
    height: 3rem;
    background: #2769dc;
    border-radius: 50%;
    line-height: 3.1875rem;
  }
  .middle {
    width: 34.6875rem;
    height: 0.75rem;
    background: #e1e9f6;
    border-radius: 0;
  }
  .First {
    background: #97c3ff;
  }
}
.isFirst {
  color: #85b8fd;
}
.Form {
  width: 31.25rem;
  margin: 5rem auto 0;
  text-align: left;
}

.active2 {
  background: #2769dc !important;
}
/deep/.el-select {
  width: 9.375rem;
  margin-right: 1.25rem;
}
/deep/.el-form-item__label::before {
  display: none;
}
.submitBtn {
  width: 23.5625rem;
  height: 3.125rem;
  background: #2769dc;
  opacity: 1;
  border-radius: 0.25rem;
}
/deep/.butan {
  border: none;
  background: #fff !important;
  line-height: 0px;
  height: 2.0625rem;
}
/deep/.el-button--primary.is-plain:hover {
  color: #2769dc;
}
</style>